import {
  DWELLER_USER_ROLE,
  LANDLORD_USER_ROLE,
  ROLE_TRANSLATION_ALIASES,
} from '../../../../../constants/user'
import { filterVisibleItems } from '../../../../../utils/common'
import {
  getUserProfileHeaderArchivedAtInfoItem,
  getUserProfileHeaderRegistrationInfoItem,
  hasUserProfileHeaderArchiveData,
  hasUserProfileHeaderRegistrationData,
  USER_EDIT_ROLE_FIELD_NAME,
} from '../../../../User'

import {
  USER_PROFILE_PAGE_HEADER_INHABITANT_EDIT_ROLE_PAYLOAD_KEY,
  UserProfilePageHeaderInhabitantInfoItemName,
} from './useUserProfilePageHeaderInhabitantInfoItems.constants'

function getUserProfilePageHeaderInhabitantCanEditRole(userData) {
  return userData?.permissions?.can_edit_role
}

function getUserProfilePageHeaderInhabitantCanEditExternalId(userData) {
  return userData?.permissions?.can_edit_external_id
}

export function getUserProfilePageHeaderInhabitantEditRolePayload(values) {
  return {
    [USER_PROFILE_PAGE_HEADER_INHABITANT_EDIT_ROLE_PAYLOAD_KEY]:
      values[USER_EDIT_ROLE_FIELD_NAME]?.value ?? null,
  }
}

export function getUserProfilePageHeaderInhabitantInfoItems({
  canViewExternalId,
  locale,
  t,
  timezone,
  userData,
}) {
  const items = [
    {
      canEdit: getUserProfilePageHeaderInhabitantCanEditRole(userData),
      isVisible: true,
      name: UserProfilePageHeaderInhabitantInfoItemName.Role,
      title: 'UserProfile.HeaderInfoItemRoleTitleKey',
      value: t(
        ROLE_TRANSLATION_ALIASES[
          userData?.isLandlord ? LANDLORD_USER_ROLE : DWELLER_USER_ROLE
        ]
      ),
    },
    {
      canEdit: getUserProfilePageHeaderInhabitantCanEditExternalId(userData),
      isVisible: canViewExternalId,
      name: UserProfilePageHeaderInhabitantInfoItemName.ExternalId,
      title: 'UserProfile.HeaderInfoItemExternalIdTitleKey',
      value: userData?.externalId,
    },
    {
      ...getUserProfileHeaderRegistrationInfoItem({
        locale,
        timezone,
        userData,
      }),
      isVisible: hasUserProfileHeaderRegistrationData(userData),
    },
    {
      ...getUserProfileHeaderArchivedAtInfoItem({
        locale,
        timezone,
        userData,
      }),
      isVisible: hasUserProfileHeaderArchiveData(userData),
    },
  ]

  return filterVisibleItems(items)
}
